import html2canvas from "html2canvas-pro";
import { toast } from "sonner";
import { isSafari } from 'react-device-detect';

export const generateTimestamp = (): string => {
    return new Date().toISOString().replace(/[:.]/g, "-");
};

export const handleTakePicture = async () => {
    const viewerElement = document.querySelector(".viewer-container") as HTMLElement;
    if (viewerElement) {
        const canvas = await html2canvas(viewerElement, {
            scale: 5, // Higher scale for better resolution
            useCORS: true, // Enable cross-origin images
            allowTaint: true, // Allow images from different origins
            logging: false, // Disable logging for better performance
        });
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png", 1.0); // Maximum quality
        link.download = `3D-Preview-image-${generateTimestamp()}.png`;
        link.click();
        toast.success("High-quality capture downloaded successfully!");
    } else {
        toast.success("Error capturing the image.");
        console.error("Viewer element not found.");
    }
};

export const handleStartRecording = (
    setRecording: React.Dispatch<React.SetStateAction<boolean>>,
    setRecordingTime: React.Dispatch<React.SetStateAction<number>>,
    mediaRecorderRef: React.MutableRefObject<MediaRecorder | null>,
    recordedChunksRef: React.MutableRefObject<Blob[]>,
    recordingIntervalRef: React.MutableRefObject<NodeJS.Timeout | null>
) => {
    const viewerCanvas = document.querySelector(".viewer-container canvas") as HTMLCanvasElement;

    if (!viewerCanvas) {
        console.error("Canvas element not found.");
        return;
    }

    const stream = viewerCanvas.captureStream(30);
    if (!stream) {
        console.error("Stream capture not supported.");
        return;
    }

    const mimeType = isSafari ? "video/mp4" : "video/webm";

    const mediaRecorder = new MediaRecorder(stream, { mimeType });
    mediaRecorderRef.current = mediaRecorder;
    recordedChunksRef.current = [];

    mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
            recordedChunksRef.current.push(event.data);
        }
    };

    mediaRecorder.onstop = () => {
        const blob = new Blob(recordedChunksRef.current, { type: mimeType });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `3D-Preview-video-${generateTimestamp()}.${isSafari ? "mp4" : "webm"}`;
        a.click();
        toast.success("Record downloaded successfully!");
        URL.revokeObjectURL(url);
    };

    mediaRecorder.start();
    setRecording(true);
    setRecordingTime(0);

    recordingIntervalRef.current = setInterval(() => {
        setRecordingTime((prevTime) => prevTime + 1);
    }, 1000);
};

export const handleStopRecording = (
    setRecording: React.Dispatch<React.SetStateAction<boolean>>,
    mediaRecorderRef: React.MutableRefObject<MediaRecorder | null>,
    recordingIntervalRef: React.MutableRefObject<NodeJS.Timeout | null>
) => {
    if (mediaRecorderRef.current) {
        mediaRecorderRef.current.stop();
        setRecording(false);
        if (recordingIntervalRef.current) {
            clearInterval(recordingIntervalRef.current);
            recordingIntervalRef.current = null;
        }
    }
};